import api from './api';

const reviewService = {
  getByProduct: (productId, params) => api.get(`/products/${productId}/reviews`, { params }),

  create: (productId, { rating, title, comment, images }) => {
    // If images present, use FormData for multipart upload
    if (images && images.length > 0) {
      const formData = new FormData();
      formData.append('rating', rating);
      if (title) formData.append('title', title);
      if (comment) formData.append('comment', comment);
      images.forEach(file => {
        if (file instanceof File) {
          formData.append('images', file);
        }
      });
      return api.post(`/products/${productId}/reviews`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    // No images — send JSON
    return api.post(`/products/${productId}/reviews`, { rating, title, comment });
  },

  markHelpful: (productId, reviewId) => api.put(`/products/${productId}/reviews/${reviewId}/helpful`),
};

export default reviewService;
